/**
 * etp.ts — ETP: documento gerado, edição, criação e seleção de preços (F6a).
 */

import type { components } from './generated/api'
import { api } from './http'

export type DocumentoETP = components['schemas']['DocumentoETP']
export type SecaoETP = components['schemas']['SecaoETP']
export type FormularioETP = components['schemas']['FormularioETP']
export type ConfiguracaoETP = components['schemas']['ConfiguracaoETP']
export type NovoETP = components['schemas']['NovoETP']
export type PesquisaPrecos = components['schemas']['PesquisaPrecos']
export type ResultadoPreco = components['schemas']['ResultadoPreco']
export type SelecaoConfirmada = components['schemas']['SelecaoConfirmada']

export function configuracaoETP() {
  return api<ConfiguracaoETP>('/api/v1/etp/configuracao')
}

export function documentoETP(id: number) {
  return api<DocumentoETP>(`/api/v1/etp/${id}`)
}

export function formularioETP(id: number) {
  return api<FormularioETP>(`/api/v1/etp/${id}/formulario`)
}

export function salvarETP(id: number, secoes: Record<string, string>) {
  return api<DocumentoETP>(`/api/v1/etp/${id}`, {
    method: 'PUT',
    body: { id, secoes },
  })
}

export function excluirETP(id: number) {
  return api<{ tinha_tr: boolean }>(`/api/v1/etp/${id}`, { method: 'DELETE' })
}

export function novoETP(id: number) {
  return api<NovoETP>(`/api/v1/etp/${id}/novo`)
}

export function salvarRascunhoETP(id: number, formData: Record<string, string>) {
  return api<{ licitacao_id: number }>(`/api/v1/etp/${id}/rascunho`, {
    method: 'POST',
    body: { form_data: formData },
  })
}

export function sugerirCampoETP(
  campo: string,
  objetoContratacao: string,
  licitacaoId: number | null,
) {
  return api<{ sugestao: string }>('/api/v1/etp/sugestao', {
    method: 'POST',
    body: {
      campo,
      objeto_contratacao: objetoContratacao,
      licitacao_id: licitacaoId,
    },
  })
}

export function pesquisaPrecos(id: number) {
  return api<PesquisaPrecos>(`/api/v1/etp/${id}/pesquisa-precos`)
}

export function confirmarPrecos(id: number, indices: number[]) {
  return api<SelecaoConfirmada>(`/api/v1/etp/${id}/pesquisa-precos`, {
    method: 'POST',
    body: { indices },
  })
}
